import { ScrollArea, Stack } from '@mantine/core';
import { NotificationMessage } from './NotificationMessage';
import { notificationsData } from './notificationsData';
export type NotificationListProps = {
  type: string;
};
export const NotificationList: React.FC<NotificationListProps> = ({
  type
}) => {
  const notifications = notificationsData.filter(item => item.type === type);
  return <>
      <ScrollArea h="calc(100vh - 300px)" type="never">
        <Stack>
          {notifications.map(item => <NotificationMessage key={item.id} {...item} />)}
        </Stack>
      </ScrollArea>
    </>;
};